function swatchExclusion(productId, container = document) {
    let lastMarket = null;
    const html           = document.documentElement;
    const swatchSelector = '.product-form__option-values [name*="Color"]';
    const swatchWrapper = container.querySelector('.product-form__color-swatches');
    if (swatchWrapper) {
        const loaderBar = document.createElement('span');
        loaderBar.className = 'product-form--swatch-loader';
        swatchWrapper.prepend(loaderBar);
    }
  const ensureVisibleSelection = () => {
      const swatchInputs = container.querySelectorAll(swatchSelector);
      const checked      = Array.from(swatchInputs).find(i => i.checked);
      if (!checked) return;
  
      const checkedLabel = checked.nextElementSibling;
      const hidden = checkedLabel &&
                      checkedLabel.classList.contains('color-swatch') &&
                      getComputedStyle(checkedLabel).display === 'none';
  
      if (hidden) {
        const firstVisible = Array.from(swatchInputs).find(i => {
          const lbl = i.nextElementSibling;
          return lbl &&
                  lbl.classList.contains('color-swatch') &&
                  getComputedStyle(lbl).display !== 'none';
        });
        if (firstVisible) firstVisible.click();   
      }
    };


  const hideSwatches = (soldOutColors = []) => {
    container.querySelectorAll(swatchSelector).forEach(input => {
      if (soldOutColors.includes(input.value)) {
        const label = input.nextElementSibling;
        if (label?.classList.contains('color-swatch')) {
          label.style.display = 'none';
        }
      }
    });
    ensureVisibleSelection();     
  };
  
  const showSwatches = () => html.classList.add('swatches-ready');

  
  const API_BASE = window.COLOR_APP_BASE || 'https://color-swatches-app-production.up.railway.app';

  const fetchInventory = (market) => {
      fetch(`${API_BASE}/inventory?productId=${productId}&market=${market}`)
      .then((res) => res.json())
      .then((data) => {
        console.log(`[${market.toUpperCase()}] Inventory response:`, data);
        if (data.sold_out_colors?.length) {
          hideSwatches(data.sold_out_colors);
        }
      })
      .catch((err) => console.error('Inventory fetch error', err))
      .finally(showSwatches);
  };

  const runCheck = () => {
    const currentMarket = window.Shopify?.country?.toLowerCase() ||
                          window.Shopify?.localization?.country?.iso_code?.toLowerCase() ||
                          document.documentElement.getAttribute('lang')?.split('-')?.pop()?.toLowerCase();

    
    if( currentMarket == 'us'){
      lastMarket = currentMarket;
      fetchInventory(currentMarket);
    }else{
      lastMarket = 'ca';
      fetchInventory('ca');      
    }
  };

  // Run the inventory check
  runCheck();
  setTimeout(showSwatches, 2000);
  };


  
  document.addEventListener('DOMContentLoaded', () => {
    let isBundleBuilder = false;
    if (document.querySelector('#main-product').dataset.handle.includes('bundle') || document.querySelector('#main-product').dataset.handle.includes('pack')) { isBundleBuilder = true; }
    if (isBundleBuilder) {
      // Handle multiple product forms in bundle builders
      const productForms = document.querySelectorAll('.product-form[data-product-id]');
      productForms.forEach(form => {
        const productId = form.getAttribute('data-product-id');
        if (productId) {
          swatchExclusion(productId, form);
        }
      });
    }else{
      const productId = window.meta?.product?.id || document.querySelector('[name="product-id"]')?.value;
      swatchExclusion(productId);  
    }
    
    const swatchInputs = document.querySelectorAll('.product-form__option-values [name="Color"]');
  
    const checkedInput = Array.from(swatchInputs).find(input => input.checked);
    
    if (!checkedInput) return;
  
    const label = checkedInput.nextElementSibling;
  
    // Check if label is hidden (e.g., via display: none)
    if (label && label.classList.contains('color-swatch') && getComputedStyle(label).display === 'none') {
      for (const input of swatchInputs) {
        const lbl = input.nextElementSibling;
        if (lbl && lbl.classList.contains('color-swatch') && getComputedStyle(lbl).display !== 'none') {
          input.click(); // Triggers native event + theme logic
          break;
        }
      } 
    }
  });
  
  
  
  